import { FC, HTMLProps } from 'react';

export const JustifyIcon: FC<HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M4.5 4.5H19.5V6H4.5V4.5ZM4.5 9H19.5V10.5H4.5V9ZM4.5 13.5H19.5V15H4.5V13.5ZM4.5 18H19.5V19.5H4.5V18Z"
        fill="currentColor"
      />
    </svg>
  );
};
